import { Component, TemplateRef, ViewChild } from "@angular/core";
import {
  ActivatedRoute,
  Router
} from "@angular/router";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { environment } from '../../shared/config/app-config';
import { FormSessionCanDeactivate, PatientService, UserService } from "../../shared";
import { User } from "../../shared/models";
import { ToastrService } from "ngx-toastr";

import {
  FormBuilder
} from "@angular/forms";
import * as _ from "lodash";
@Component({
  selector: "app-patsummary",
  templateUrl: "./patsummary.component.html",
  styleUrls: ["./patsummary.component.css"]
})
export class PatsummaryComponent extends FormSessionCanDeactivate {
  dateformat: string;
  dateform: string;
  bsConfig: {
    containerClass: string;
    showWeekNumbers: boolean;
    dateInputFormat: any;
  };
  setmask: string;
  hospitalList: any[];
  modalRef14: BsModalRef;
  modalRef13: BsModalRef;
  bodyside: any[];
  temp: boolean;
  addpart: any[];
  enablemenu: any;
  disabled: boolean;
  tempbodypart: any;
  saveenabled: boolean = true;
  imgMaxSize: any;
  modalRef: BsModalRef;
  public imageURL: string = environment.cloudeImageURL;
  Backdrop: true;

  resabs: string;
  note: any = "";
  title: any = "";
  resp: string;
  // myInputVariable: any;
  // public patientUrl  ='./assets/img/users/Default_carepartner_female.svg'
  // public defaultUl ='./assets/img/users/Default_carepartner_female.svg'
  respass: string;
  oneAtATime: boolean = true;
  enableshow: boolean = false;
  enable: boolean = true;
  public temp_var: boolean = false;
  public message: any;
  modaldata: any;
  apiurl: any = environment.api_url;
  public timealert = environment.timelimit;
  surveyform: any;
  public params: any;
  actbody: any;
  public data: Object;
  private fb: FormBuilder;
  @ViewChild("videoPlayer") videoplayer: any;
  documenturl: string = environment.documenturl;
  public carepath: any = {};
  public patapp;
  public biograph: any;
  public carefamily: any;
  public patsum: any = {};
  public Status: any;
  public datapost: any = {};
  public dataed: any = {};
  public documentsdata: any = [];
  public docedit: any = {
    DocDesc: "",
    DocTitle: ""
  };
  public pad: any = {};
  patap: any;
  mcare: any;
  pcare: any;
  plist: any = [];
  public patname: any;
  patid: any;
  patcare: any;
  getact: any;
  currentUser: User;
  user: any;
  getapp: any;
  open: any;
  episodeid: any;
  patfamily: any;
  public checkDos: any;
  public patientAppoinmentList = [];
  activityboard: any;
  dtOptions: any = {};
  imageChangedEvent: any = "";
  croppedImage: any = "";
  cropperReady = false;
  public today = new Date();
  public mintimeset = 0;
  setImage: boolean = false;
  public timeArray = [
    {
      value: "07:00 AM",
      name: "07:00 AM",
      check: 7
    },
    {
      value: "07:30 AM",
      name: "07:30 AM",
      check: 7.5
    },
    {
      value: "08:00 AM",
      name: "08:00 AM",
      check: 8
    },
    {
      value: "08:30 AM",
      name: "08:30 AM",
      check: 8.5
    },
    {
      value: "09:00 AM",
      name: "09:00 AM",
      check: 9
    },
    {
      value: "09:30 AM",
      name: "09:30 AM",
      check: 9.5
    },
    {
      value: "10:00 AM",
      name: "10:00 AM",
      check: 10
    },
    {
      value: "10:30 AM",
      name: "10:30 AM",
      check: 10.5
    },
    {
      value: "11:00 AM",
      name: "11:00 AM",
      check: 11
    },
    {
      value: "11:30 AM",
      name: "11:30 AM",
      check: 11.5
    },
    {
      value: "12:00 PM",
      name: "12:00 PM",
      check: 12
    },
    {
      value: "12:30 PM",
      name: "12:30 PM",
      check: 12.5
    },
    {
      value: "01:00 PM",
      name: "01:00 PM",
      check: 13
    },
    {
      value: "01:30 PM",
      name: "01:30 PM",
      check: 13.5
    },
    {
      value: "02:00 PM",
      name: "02:00 PM",
      check: 14
    },
    {
      value: "02:30 PM",
      name: "02:30 PM",
      check: 14.5
    },
    {
      value: "03:00 PM",
      name: "03:00 PM",
      check: 15
    },
    {
      value: "03:30 PM",
      name: "03:30 PM",
      check: 15.5
    },
    {
      value: "04:00 AM",
      name: "04:00 PM",
      check: 16
    },
    {
      value: "04:30 PM",
      name: "04:30 PM",
      check: 16.5
    },
    {
      value: "05:00 PM",
      name: "05:00 PM",
      check: 17
    },
    {
      value: "05:30 PM",
      name: "05:30 PM",
      check: 17.5
    },
    {
      value: "06:00 PM",
      name: "06:00 PM",
      check: 18
    },
    {
      value: "06:30 PM",
      name: "06:30 PM",
      check: 18.5
    },
    {
      value: "07:00 PM",
      name: "07:00 PM",
      check: 19
    }
  ];
  menu: any;
  excludeBundle: boolean;
  menustatus: any = {
    message: false,
    appoinment: false,
    document: false
  };
  bodypartCopy: any = [];
  bodylocation: any = [];
  public bodypart: any = {
    anybodypart: this.bodypartCopy.patServiceLineLabel
  };

  bodyloc: any = [];

  bodyl: any;
  frac: boolean;
  locat: any;
  changetype: any;
  constructor(
    private patientservice: PatientService,
    private router: ActivatedRoute,
    private nav: Router,
    private modalService: BsModalService,
    private userService: UserService,
    private toast: ToastrService
  ) {
    super();
  }

  log(event: boolean, i) {
    this.activityboard[i].open = event;

    //////console.log(this.activityboard[i].open);
  }
  /*video(template: TemplateRef<any>,video) {
    this.modalRef = this.modalService.show(template);
    this.actbody = video;
  }  */
  openedit(template: TemplateRef<any>, bodypart: any) {
    this.getBodyPart();
    this.modalRef = this.modalService.show(template, {
      backdrop: "static"
    });
    this.bodypart = Object.assign({}, bodypart);
    this.bodypartCopy = bodypart;
    ////console.log("bodypart", bodypart.Fracture);
    ////console.log("bodypart", this.bodypartCopy);
    ////console.log("bodypart1", this.bodypartCopy.patServiceLineLabel);
    if (bodypart.Fracture == "Y") {
      this.frac = true;
    } else {
      this.frac = false;
    }
    ////console.log("frac", this.frac);
  }
  openeditlat(template1: TemplateRef<any>, bodypart: any) {
    if (
      bodypart.patServiceLineLaterality != "Back" &&
      bodypart.patServiceLineLaterality != "Neck"
    ) {
      this.showlist(template1, bodypart.patServiceLineLabel);
      this.bodyl = bodypart.patServiceLineLaterality;
    }
  }
  showlist(template1, bodypart) {
    this.patientservice.getuserid(this.patid.patientId).subscribe(data => {
      this.temp_var = true;
      if (Array.isArray(data) && data.length) {
        this.addpart = data;

        if (bodypart != "") {
          this.temp = true;
          let f2 = this.addpart[0].allServiceLineLabel.split(",");
          let temarray = _.filter(
            f2,
            (o: any): any => {
              return o.includes(bodypart);
            }
          );
          if (temarray.length > 1) {
            this.bodyside = [];
            return;
          }
          for (let i = 0; i < f2.length; i++) {
            let te;
            if (
              bodypart == "Hip and Femur Fracture (SHFFT)" &&
              f2[i].includes("Hip and Femur Fracture (SHFFT)")
            ) {
              f2[i] = f2[i].replace("(SHFFT)", "");
            }
            te = f2[i].split("(");
            te[1] = te[1].replace(")", "");
            te[1] = te[1].replace(/\s/g, "");
            te[0] = te[0].replace(/\s/g, "");
            f2[i] = te;
            if (
              bodypart.replace(/\s/g, "") == te[0] ||
              te[0] == "HipandFemurFracture"
            ) {
              if (te[1] == "Left") {
                this.bodyside = ["Right", "Bilateral"];
                return;
              } else if (te[1] == "Right") {
                this.bodyside = ["Left", "Bilateral"];
                return;
              } else if (te[1] == "Bilateral") {
                this.temp = false;

                return;
              }
            }
          }
        } else {
          this.temp = false;
        }
      }
    });
    this.modalRef13 = this.modalService.show(template1, {
      backdrop: "static"
    });
  }
  openedithos(template2: TemplateRef<any>, hospital: any) {
    this.showhoslist(template2, hospital);
    this.bodyl = hospital;
  }
  showhoslist(template2, hosp) {
    let self = this;
    self.patientservice
      .getHospitalList(self.currentUser.item.userAccountId)
      .subscribe(data => {
        this.hospitalList = _.filter(data.aaData, o => {
          return o.hospitalId != 10001;
        });
      });
    this.modalRef14 = this.modalService.show(template2, {
      backdrop: "static"
    });
  }
  close() {
    this.modalRef.hide();
    this.saveenabled = true;
  }
  close1() {
    this.modalRef13.hide();
    this.saveenabled = true;
  }
  close2() {
    this.modalRef14.hide();
    this.saveenabled = true;
  }

  update(template: TemplateRef<any>) {
    this.getAppoinmentsList(this.patid.patientSWFId);
    this.modalRef = this.modalService.show(template, {
      class: "modal-lg",
      backdrop: "static"
    });
    this.movable();
  }

  document(template: TemplateRef<any>) {
    this.resabs = " ";
    this.croppedImage = "";
    this.modalRef = this.modalService.show(template, {
      backdrop: "static"
    });
  }
  editdocumentss(template: TemplateRef<any>, doc: any) {
    // //////console.log("doc", doc)
    this.resabs = " ";
    //this.setImage = true;
    this.docedit = Object.assign({}, doc);
    this.croppedImage = environment.api_url + this.docedit.DocPath;
    //this.fileChangedEventedit(event);
    //	this.imageChangedEvent = this.croppedImage;
    // //////console.log(this.docedit);
    this.modalRef = this.modalService.show(template, {
      backdrop: "static"
    });
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {
      class: "modal-sm",
      backdrop: "static"
    });
    this.movable();
  }

  ngOnInit() {
    this.userService.currentUser.subscribe(userData => {
      this.currentUser = userData;
    });
    if (this.currentUser.item) {
      this.setmask = this.currentUser.item.phoneFormat.split("#").join("0").concat('0');

      if (this.currentUser.item.dateFormat.toLowerCase() == "mmddyyyy") {
        this.dateformat = environment.dateFormat;
        this.dateform = environment.dateForm;
      } else if (this.currentUser.item.dateFormat.toLowerCase() == "ddmmyyyy") {
        this.dateformat = "DD/MM/YYYY";
        this.dateform = "dd/MM/yyyy";
      }
      this.bsConfig = Object.assign(
        {},
        {
          containerClass: "theme-dark-blue",
          showWeekNumbers: false,
          dateInputFormat: this.dateformat
        }
      );
    }
    if (this.currentUser.item.hostModel == "CLOUD")
      this.imageURL = environment.cloudeImageURL;
    else this.imageURL = environment.vmImageURL;

    this.router.params.subscribe(params => {
      this.patid = params;
    });
    // this.getScanDocuments();
    // this.getPatientDetails();

    // Get Exclude Bundle
    this.userService
      .getExcludeBundle(this.patid.patientSWFId)
      .subscribe(data => {
        this.excludeBundle = data.excludeBundle;
        ////console.log("BundleInfo", this.excludeBundle);
      });

    //////console.log('id ' + this.patid.patientId);
    //////console.log("params", this.patid.patientSWFId)
    //////console.log("params", this.patid.patientName)
    // this.patientservice
    //   .getPatsum(this.patid.patientId, this.patid.patientSWFId)
    //   .subscribe(data => {
    //     this.patsum = data;
    //   });
    // this.getAppoinments();

    // this.getcarepath();

    // this.patientservice
    //   .getcarefamily(this.patid.patientId, this.patid.patientSWFId)
    //   .subscribe(data => {
    //     this.carefamily = data.CareNavigatorDetails;
    //     ////console.log(this.carefamily);
    //     //this.patfamily = data;
    //     //this.carefamily=this.patfamily.concat(this.plist);
    //   });

    // this.patientservice
    //   .getpatapp(this.patid.patientId, this.patid.patientSWFId)
    //   .subscribe(data => {
    //     if (data) this.patapp = data;
    //     else this.patapp = null;
    //   });

    // this.patientservice.getbio(this.patid.patientId).subscribe(data => {
    //   this.biograph = data.profileQuestions;
    // });

    // this.patientservice
    //   .getpatcare(this.patid.patientId, this.patid.patientSWFId)
    //   .subscribe(data => {
    //     this.mcare = data;
    //     //this.patcare = this.mcare.concat(this.pcare);
    //     this.patcare = this.mcare.HospitalCareNavigatorDetails.concat(
    //       this.mcare.CareNavigatorDetails
    //     );
    //     ////console.log(this.patcare);
    //   });

    // this.patientservice.getcarelist(this.patid.patientId).subscribe(data => {
    //   this.pcare = data;
    // });

    // this.patientservice.getpatlist(this.patid.patientId).subscribe(data => {
    //   this.plist = data;
    //   ////console.log(this.plist);
    // });
    this.patientservice
      .getepisodeid(this.patid.patientSWFId)
      .subscribe(data => {
        this.episodeid = data;
      })
    this.patientservice.getact(this.patid.patientSWFId).subscribe(data => {
      this.activityboard = data;
      // setTimeout(()=>{
      //   this.activityboard = this.userService.getCustomActivityBoard()},2000);
    });





    this.dtOptions = {
      // Configure the pagelength
      pageLength: 10,
      lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]]
    };

    // this.getmenu();
    if (
      this.currentUser.item.userrole == "Care Navigator" ||
      this.currentUser.item.userrole == "Care Coordinator" ||
      this.currentUser.item.userrole == "Hospital Care Navigator" ||
      this.currentUser.item.userrole == "Commercial Care Navigator"
    ) {
      this.disabled = false;
    } else {
      this.disabled = true;
    }
  }
  // getcarepath() {
  //   this.patientservice
  //     .getcarepath(this.patid.patientId, this.patid.patientSWFId)
  //     .subscribe(data => {
  //       this.carepath = data;
  //       ////console.log(this.carepath);
  //     });
  // }
  getmenu() {
    //, this.currentUser.item.userAccountId
    this.userService
      .menuuserinfo(19, this.currentUser.item.userAccountId)
      .subscribe(data => {
        this.menu = data;

        ////console.log(this.menu);
        if (this.menu) {
          for (var i = 0; i < this.menu.length; i++) {
            if (this.menu[i].refName == "PAT_MESSAGES") {
              this.menustatus.message = this.menu[i].status;
            } else if (this.menu[i].refName == "PAT_APPOINTMENTS") {
              this.menustatus.appoinment = this.menu[i].status;
            } else if (this.menu[i].refName == "DOCUMENT_ALL") {
              this.menustatus.document = this.menu[i].status;
            }
          }

          ////console.log(this.menustatus);
        }
      });

    this.patientservice
      .getappvisible(this.patid.patientId, 11, this.currentUser.item.appRoles)
      .subscribe(data => {
        this.enablemenu = data[0].status;
      });
  }

  getPatientDetails() {
    let self = this;
    self.patientservice
      .getpatientinfo(self.patid.patientId, self.patid.patientSWFId)
      .subscribe(data => {
        if (Array.isArray(data) && data.length) {
          self.user = data[0];
        }
      });
  }

  getAppoinments() {
    this.patientservice.getapp(this.patid.patientSWFId).subscribe(data => {
      this.getapp = data;
    });
  }
  updatedetils() {
    //////console.log();
    let careDetails = {
      'patientId': this.patid.patientId,
      'patientSWFId': this.patid.patientSWFId,
      'patientName': this.patid.patientName,
      'patstatus': this.patid.cn,
      'status': '',
      'partnerstatus': '',
      'uid': ''
    }
    window.localStorage['careDetails'] = btoa(JSON.stringify(careDetails))
    this.nav.navigate([`care/addpartner`]);
  }

  updategiver() {
    let careGiverDetails = {
      'patientId': this.patid.patientId,
      'patientSWFId': this.patid.patientSWFId,
      'statusid': this.carepath.Status,
      'patstatus': this.params.patstatus,
      'status': this.params.status
    }
    window.localStorage['careGiverDetails'] = btoa(JSON.stringify(careGiverDetails))
    this.nav.navigate([`care/addgiver`])
  }

  pauseOrPlay(video) {
    video.pause();
    video.currentTime = 0;

    //////console.log(this.actbody.materialHspPatientMappingId)
    //////console.log(this.actbody.materialType)
    this.userService
      .updatesurvey(
        this.actbody.materialHspPatientMappingId,
        this.actbody.materialType
      )
      .subscribe(data => {
        this.surveyform = data;
        //////console.log(data);
        if (data.updateStatus == "true") {
          this.userService.logAudit("updatereviewstatus", 0).subscribe(data => { })
          this.patientservice
            .getact(this.patid.patientSWFId)
            .subscribe(data => {
              this.activityboard = data;
            });
        }
      });
  }

  //get appoinments by patient swf id
  getAppoinmentsList(id) {
    let self = this;
    self.patientservice.getAppoinmentsListwitSWFid(id).subscribe(data => {
      self.checkDos = new Date(self.user.dos);
      self.patientAppoinmentList = _.map(data, self.changeDateFormat);
    });
  }

  //chnage the date formate for date picker

  changeDateFormat(n) {
    if (n.appointmentDate) {
      n.appointmentDate = new Date(n.appointmentDate);
    }
    if (n.completedDate) {
      n.completedDate = new Date(n.completedDate);
    }
    return n;
  }

  //check current appointment can editable
  checkAppoinment(i) {
    let self = this;
    var booleanArray = [];
    for (let j = i; j < 5; j++) {
      if (self.patientAppoinmentList[j].completedDate) {
        booleanArray.push(true);
      }
    }
    if (booleanArray.length) {
      return booleanArray.includes(true);
    } else {
      return false;
    }
  }

  //save appointments
  saveAppoinments() {
    let self = this;
    self.changeDateFormat(self.patientAppoinmentList);
    let loginHospitalId: any;
    loginHospitalId = this.currentUser.item ? this.currentUser.item.userAccountKey : 0;
    self.arrangaData(self.patientAppoinmentList).then(
      data => {
        self.patientservice.saveAppoinments(data, loginHospitalId, this.patid.patientSWFId).subscribe(data => {
          self.toast.success(data[0].message, "", {
            timeOut: this.timealert
          });
          this.userService.logAudit('savePatientAppointment', 0).subscribe(data => { })
          self.getAppoinments();
          self.modalRef.hide();
        });
      },
      err => { }
    );
  }
  //time validation
  checkTime(event, i) {
    let self = this;
    if (event) {
      if (self.patientAppoinmentList[i].appointmentDate) {
        let today = new Date();
        let timeNow = new Date().getHours();
        let min = new Date().getMinutes();
        let appointmentDate = new Date(
          self.patientAppoinmentList[i].appointmentDate
        );
        if (
          today.setHours(0, 0, 0, 0) == appointmentDate.setHours(0, 0, 0, 0)
        ) {
          if (min > 30) {
            self.mintimeset = timeNow + 1;
          } else {
            self.mintimeset = timeNow + 0.5;
          }
        } else {
          self.mintimeset = 0;
        }
      }
    }
  }

  //arange data before save
  arrangaData(dataArray) {
    let self = this;

    let promise = new Promise((resolve, reject) => {
      for (let i = 0; i < dataArray.length; i++) {
        if (dataArray[i].appointmentDate) {
          if (!dataArray[i].appoinmentWithId) {
            self.toast.error(
              "Please Select surgeon name for the process ${dataArray[i].appointmentTitle}",
              "",
              {
                timeOut: this.timealert
              }
            );
            reject("Error");
          }
        }
        if (!dataArray[i].appointmentDate) {
          dataArray[i].appointmentDate = null;
        }
        if (!dataArray[i].appointmentTime) {
          dataArray[i].appointmentTime = null;
        }
      }
      resolve(dataArray);
    });
    return promise;
  }

  //cancel the appointment
  cancelAppointment(index, data) {
    let self = this;
    if (data.appointmentDate && data.appoinmentWithId) {
      self.patientservice.cancelAppoinments(data).subscribe(res => {
        if (index == 0) {
          self.patientAppoinmentList[index].appointmentTime = 0;
        }
        self.patientAppoinmentList[index].appointmentDate = "";
        self.patientAppoinmentList[index].appoinmentWithId = "";
        self.toast.success(this.userService.translateText('hospital_portal.appointments.appointment_was_cancelled.error'), "", {
          timeOut: this.timealert
        });
        this.userService.logAudit('cancelPatientAppointment', 0).subscribe(data => { })
        // self.getAppoinmentsList(data.patientSwfId)
      });
    }
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;

    let acceptFormat = ["image/png", "image/x-png", "image/jpeg", "image/jpg"];
    //////console.log(this.imageChangedEvent.srcElement);
    if (
      !acceptFormat.includes(this.imageChangedEvent.srcElement.files[0].type)
    ) {
      this.toast.error(
        this.userService.translateText('patient_portal.validations.file_not_allowed.error_label'),
        "",
        {
          timeOut: this.timealert
        }
      );
      this.imageChangedEvent = "";
      // this.croppedImage = this.defaultUl;
      return;
    } else if (
      this.imageChangedEvent.srcElement.files[0].size > this.imgMaxSize
    ) {
      this.toast.error(
        this.userService.translateText('patient_portal.validations.maximum_size_exceed.error_label'),
        "",
        {
          timeOut: this.timealert
        }
      );
      this.imageChangedEvent = "";
      // this.croppedImage = this.defaultUl;
      return;
    }

    // //////console.log(this.imageChangedEvent.srcElement.files[0].name);
  }

  imageCropped(image: string) {
    this.croppedImage = image;

    // //////console.log(this.croppedImage);
  }
  imageLoaded() {
    this.cropperReady = true;
  }
  imageLoadFailed() {
    //////console.log('Load failed');
  }

  getScanDocuments() {
    this.patientservice
      .getdocuments(this.patid.patientId, this.patid.patientSWFId)
      .subscribe(data => {
        this.documentsdata = data;
        //////console.log(this.documentsdata);
      });
  }

  clearall() {
    this.imageChangedEvent = "";
    this.croppedImage = "";
    this.pad.title = "";
    this.pad.note = "";
    this.resabs = " ";
  }
  postdoc(temppassword, da) {
    this.enableshow = true;

    this.enable = false;
    //////console.log(da.value);
    // //////console.log("in", this.title, this.note);
    if (this.imageChangedEvent.srcElement != undefined) {
      // //////console.log("in", this.title, this.note);
      this.datapost = {
        docTitle: da.value.title,
        docNote: da.value.note,
        patientId: this.patid.patientId,
        PatientSWFId: this.patid.patientSWFId,
        uploadimage: [
          {
            filename: this.imageChangedEvent.srcElement.files[0].name,
            filetype: this.imageChangedEvent.srcElement.files[0].type,
            value: this.croppedImage.split(",")[1]
          }
        ]
      };

      this.patientservice.postdocuments(this.datapost).subscribe(data => {
        if (data) {
          this.enableshow = true;

          this.enable = false;

          this.modalRef.hide();
          this.respass = this.userService.translateText('hospital_portal.disp_messages.document_added.success');
          this.modalRef = this.modalService.show(temppassword, {
            class: "modal-sm",
            backdrop: "static"
          });
          this.movable();
          this.getScanDocuments();
          this.imageChangedEvent = "";
          this.croppedImage = "";
          this.pad.title = "";
          this.pad.note = "";

          this.datapost = {};
        } else {
          this.enableshow = true;
          this.enable = false;
          this.respass = this.userService.translateText('hospital_portal.disp_messages.enter_valid_data.error');
        }
        this.getScanDocuments();
        this.enableshow = false;
        this.enable = true;
      });
    } else {
      this.resabs = this.userService.translateText('hospital_portal.disp_messages.upload_image.error');
      //////console.log("Outtt");
    }
  }

  checkMinDate(index, ...arg) {
    let date = arg;
    let temArray = [];
    if (index == 2) {
      if (date[0]) {
        return date[0];
      }
    }
    let todateTime = new Date().getTime();
    for (let i = 0; i < date.length; i++) {
      if (date[i]) {
        let temtime = new Date(date[i]).getTime();
        if (temtime > todateTime) {
          return new Date(temtime);
        }
      }
    }
    return new Date();
  }

  fileChangedEventedit(event: any): void {
    //event.srcElement.value = this.croppedImage;
    this.imageChangedEvent = event;
    this.setImage = false;

    let acceptFormat = ["image/png", "image/x-png", "image/jpeg", "image/jpg"];
    //////console.log(this.imageChangedEvent.srcElement);
    if (
      !acceptFormat.includes(this.imageChangedEvent.srcElement.files[0].type)
    ) {
      this.toast.error(this.userService.translateText('patient_portal.validations.file_not_allowed.error_label'), "", {
        timeOut: this.timealert
      });
      this.imageChangedEvent = "";
      // this.croppedImage = this.defaultUl;
      return;
    } else if (
      this.imageChangedEvent.srcElement.files[0].size > this.imgMaxSize
    ) {
      this.toast.error(
        this.userService.translateText('patient_portal.validations.maximum_size_exceed.error_label'),
        "",
        {
          timeOut: this.timealert
        }
      );
      this.imageChangedEvent = "";
      // this.croppedImage = this.defaultUl;
      return;
    }

    // //////console.log(this.imageChangedEvent.srcElement.files[0].name);
  }

  updatedoc(edited, ed) {
    //////console.log(ed);
    // //////console.log(this.imageChangedEvent.srcElement.files[0].name);
    // //////console.log("in", this.title, this.note);
    // //////console.log(this.docedit.DocDesc, this.docedit.DocTitle);

    if (this.docedit.DocDesc && this.docedit.DocTitle) {
      if (this.imageChangedEvent.srcElement != undefined) {
        this.dataed = {
          patientScannedDocId: this.docedit.DocId,
          docTitle: this.docedit.DocTitle,
          docNote: this.docedit.DocDesc,
          patientId: this.patid.patientId,
          PatientSWFId: this.patid.patientSWFId,
          uploadimage: [
            {
              filename: this.imageChangedEvent.srcElement.files[0].name,
              filetype: this.imageChangedEvent.srcElement.files[0].type,
              value: this.croppedImage.split(",")[1]
            }
          ]
        };
        //////console.log(this.dataed);
        this.patientservice.editdocuments(this.dataed).subscribe(data => {
          //////console.log(data);
          if (data) {
            this.modalRef.hide();
            this.respass = this.userService.translateText('hospital_portal.disp_messages.doc_updated.success');
            this.modalRef = this.modalService.show(edited, {
              class: "modal-sm",
              backdrop: "static"
            });
            this.movable();
            this.getScanDocuments();
            this.imageChangedEvent = "";
            this.croppedImage = "";
            this.pad.title = "";
            this.pad.note = "";

            this.datapost = {};
          } else {
            this.respass = this.userService.translateText('hospital_portal.disp_messages.enter_valid_data.error');
          }
        });
      } else {
        this.dataed = {
          patientScannedDocId: this.docedit.DocId,
          docTitle: this.docedit.DocTitle,
          docNote: this.docedit.DocDesc,
          patientId: this.patid.patientId,
          PatientSWFId: this.patid.patientSWFId,
          uploadimage: [{}]
        };
        //////console.log(this.dataed);
        this.patientservice.editdocuments(this.dataed).subscribe(data => {
          //////console.log(data);
          if (data) {
            this.modalRef.hide();
            this.respass = this.userService.translateText('hospital_portal.disp_messages.doc_updated.success');
            this.modalRef = this.modalService.show(edited, {
              class: "modal-sm",
              backdrop: "static"
            });
            this.movable();
            // this.fileChangeEvent('');
            this.croppedImage = "";
            this.pad.title = "";
            this.pad.note = "";
            this.getScanDocuments();
          } else {
            this.respass = this.userService.translateText('hospital_portal.disp_messages.enter_valid_data.error');
          }
        });
      }
    } else {
      this.resabs = "Enter all the fields";
      //////console.log("Outtt");
    }
  }
  getBodyPart() {
    let self = this;
    self.patientservice
      .getBodyLocation(this.currentUser.item.userAccountKey)
      .subscribe(data => {
        self.bodyloc = data;
        ////console.log("bodylo", this.bodypartCopy.patServiceLineLaterality);
        ////console.log("body", this.bodypartCopy.patServiceLineLabel);
        let index = _.findIndex(
          self.bodyloc.ServicelineLabel,
          (o: any): any => {
            return o.ServicelineLabel == this.bodypartCopy.patServiceLineLabel;
          }
        );

        if (index != -1)
          this.locat = self.bodyloc.ServicelineLabel[index].Location;
        this.bodyl = this.bodypartCopy.patServiceLineLabel;
        this.tempbodypart = this.bodyl;
        ////console.log(this.locat);
        ////console.log(this.bodyl);
        /* if((this.bodypartCopy.patServiceLineLabel == 'Partial Knee Replacement') || (this.bodypartCopy.patServiceLineLabel == 'Total Knee Replacement')){
        this.bodyloc.ServicelineLabel.push({
          'Location':'Knee',
          'ServicelineLabel':'Partial Knee Replacement'
        	
          })
          this.bodyloc.ServicelineLabel = this.bodyloc.ServicelineLabel.push(this.bodyloc.ServicelineLabel,{Location:'Knee'})
          //this.bodyloc.ServicelineLabel= _.reject(this.bodyloc.ServicelineLabel,{Location:'Neck'})
        }
          if((this.bodypartCopy.patServiceLineLabel == 'Total Hip Replacement') || (this.bodypartCopy.patServiceLineLabel == 'Partial Hip Replacement') || (this.bodypartCopy.patServiceLineLabel == 'Hip and Femur Fracture (SHFFT)')){
        this.bodyloc.ServicelineLabel= _.reject(this.bodyloc.ServicelineLabel,{Location:'Knee'})
        this.bodyloc.ServicelineLabel= _.reject(this.bodyloc.ServicelineLabel,{Location:'Neck'})
          ////console.log("bodylo1",this.bodyloc)
          }
          if(this.bodypartCopy.patServiceLineLabel == 'Cervical Fusion'){
            this.bodyloc.ServicelineLabel= _.reject(this.bodyloc.ServicelineLabel,{Location:'Knee'})
            this.bodyloc.ServicelineLabel= _.reject(this.bodyloc.ServicelineLabel,{Location:'Hip'})
              ////console.log("bodylo1",this.bodyloc)
              }
        for(let i =0;i< this.bodyloc.ServicelineLabel.length;i++){
          if(this.bodyloc.ServicelineLabel[i].ServicelineLabel == this.bodypartCopy.patServiceLineLabel){
          // this.bodyl=	this.bodyloc.ServicelineLabel[i].ServicelineLabel.splice(this.bodypartCopy.patServiceLineLabel)
          // ////console.log(this.bodyl)
          this.bodyl = this.bodyloc.ServicelineLabel[i].ServicelineLabel
            this.bodylocation = this.bodyloc.ServicelineLabel[i].Location
            ////console.log(this.bodylocation)
            ////console.log(this.bodyl)
  	
          }
        } */
      });
  }
  toggleEditable(event) {
    ////console.log("save", event);
  }
  changepart(part) {
    ////console.log("save", part);
    this.changetype = part;
    if (this.tempbodypart == part) {
      this.saveenabled = true;
    } else {
      this.saveenabled = false;
    }
    if (
      this.changetype == "Partial Hip Replacement" ||
      this.changetype == "Hip and Femur Fracture (SHFFT)"
    ) {
      this.frac = true;
    } else {
      this.frac = false;
    }
  }
  changelat(part) {
    ////console.log("save", part);
    this.changetype = part;
    if (this.carepath.patServiceLineLaterality == part) {
      this.saveenabled = true;
    } else {
      this.saveenabled = false;
    }
  }
  savepbodypart(save) {
    ////console.log("save", save);
    ////console.log("save", this.frac);
    this.patientservice
      .bodypartsave(
        save,
        this.frac,
        this.patid.patientSWFId,
        this.currentUser.item.userAccountId
      )
      .subscribe(data => {
        ////console.log(data);
        if (data.status == "true") {
          this.ngOnInit();
          this.modalRef.hide();
          this.saveenabled = true;
          this.toast.success(data.message, "", {
            timeOut: this.timealert
          });
        } else {
          this.toast.error(data.message, "", {
            timeOut: this.timealert
          });
        }
      });
  }
  getpage(actbody, status) {
    if (status != "Not Assigned") {
      if (actbody.oldResultId) {
        return `/care/documepage1/${this.patid.patientId}/${this.patid.patientSWFId
          }/${actbody.materialHspPatientMappingId}/${actbody.materialName}/${actbody.reviewStatus
          }/${actbody.oldResultId}`;
      } else {
        return (
          `/care/documepage1/${this.patid.patientId}/${this.patid.patientSWFId
          }/${actbody.materialHspPatientMappingId}/${actbody.materialName}/${actbody.reviewStatus
          }/` + "0"
        );
      }
    } else {
      if (actbody.oldResultId) {
        return `/care/documepage1/${this.patid.patientId}/${this.patid.patientSWFId
          }/${actbody.materialHspPatientMappingId}/${actbody.materialName
          }/Not Assigned/${actbody.oldResultId}`;
      } else {
        return (
          `/care/documepage1/${this.patid.patientId}/${this.patid.patientSWFId
          }/${actbody.materialHspPatientMappingId}/${actbody.materialName
          }/Not Assigned/` + "0"
        );
      }
    }
  }
  navgiater() {
    let patDetails = {
      'patientId': this.patid.patientId,
      'patientSWFId': this.patid.patientSWFId,
      'patstatus': this.carepath.Status,
      'status': false
    }
    window.localStorage['patDetails'] = btoa(JSON.stringify(patDetails))
    this.nav.navigate([`/care/patientdetails`]);
  }

  documen(actbody) {
    //this.userService.documentURL = actbody.filePath;
    let pdfOption = {
      'type': actbody.fileType ? actbody.fileType : 'pdf',
      'path': actbody.filePath
    }
    if (pdfOption.type == 'html')
      pdfOption.path = actbody.htmlPath
    window.localStorage['pdfPath'] = JSON.stringify(pdfOption);
    this.nav.navigate([
      `/care/surveymetrics/${actbody.materialHspPatientMappingId}/${this.patid.patientSWFId
      }/${this.patid.patientId}/${this.patid.patientName}/${actbody.productId}`
    ]);
    // routerLink="/patient/preventinginfection/{{actbody.materialHspPatientMappingId}}/{{actbody.reviewStatus}}/{{actbody.materialId}}/{{this.swfid}}/{{actbody.productId}}/{{actbody.filePath}}"
  }
  movable() {
    $(function () {
      let modalContent: any = $(".modal-content");
      let modalHeader = $(".modal-header");
      modalHeader.addClass("cursor-all-scroll");
      modalContent.draggable({
        handle: ".modal-header"
      });
    });
  }
  getexpiryDueDate(assignDate, dueDate) {
    if (assignDate && dueDate) {
      let oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
      dueDate = new Date(dueDate);
      assignDate = new Date(assignDate);

      let diffDays = Math.round(Math.abs((dueDate - assignDate) / oneDay));
      if (diffDays == 10000) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }
}
